import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { mockData } from '../data/mock';
import { Lightbulb, Shield, Award } from 'lucide-react';

const iconMap = {
  Lightbulb: Lightbulb,
  Shield: Shield,
  Award: Award
};

const ValuesSection = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Why Choose Us",
      subtitle: "Our Core Values"
    },
    ar: {
      title: "لماذا تختارنا",
      subtitle: "قيمنا الأساسية"
    }
  };

  const t = content[language];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-xl text-gray-600">{t.subtitle}</p>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {mockData.values.map((value) => {
            const IconComponent = iconMap[value.icon];
            return (
              <div
                key={value.id}
                className="group text-center p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-teal-50/30 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors duration-300">
                  <IconComponent className="w-10 h-10 text-teal-600 group-hover:text-white transition-colors duration-300" />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {value.title[language]}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description[language]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
